import { Branch } from '../../components/deck';
import { equalsOrContains } from '../../modules/employment-helper';
import { creditAuthorizationBranch } from './credit-authorization';
import { hasCoborrowerWithAcceptedOfferBranch } from './has-coborrower-with-accepted-offer';

export const acceptedOfferCreditBranch = (continuation) =>
  Branch(
    {
      noOfferAccepted: creditAuthorizationBranch(continuation),
      salariedPreapproved: hasCoborrowerWithAcceptedOfferBranch(continuation)
    },
    ({ model }) => {
      const employment = model.getIn(['borrower', 'employment']);
      return (model.getIn(['loan', 'previousPreapproval']) &&
        equalsOrContains('Salaried', employment)) ||
        model.getIn(['loan', 'acceptedOffer'])
        ? 'salariedPreapproved'
        : 'noOfferAccepted';
    },
    continuation
  );



// WEBPACK FOOTER //
// ./src/decks/branches/accepted-offer-credit.js